import { useMutation } from "@tanstack/react-query";
import { useAuth } from "../../../../../Context/AuthContext";
import { getRCSReportByPartners } from "../api/RCSReportByPartners";
export const useRCSByPartners = () => {
  const auth = useAuth();
  const user = auth.getSessionData();

  return useMutation({
    mutationKey: ["getRCSReportByPartners"],
    mutationFn: async (data) =>
      await getRCSReportByPartners({
        token: user.token,
        data: {
          ...data,
          uid_user: user?.uid_user,
        },
      }),
  });
};
